// Import JS files from Mindstyle Core plugin
import "../../../../plugins/wpg-mindstyle-core/src/assets/js/components/check-page-rendering";
import "../../../../plugins/wpg-mindstyle-core/src/assets/js/components/smooth-scroll";

// files from theme
import "./components/header";
import "./components/navigation";
import "./components/awin";
import { initFixedHeader } from './components/header-scroll.js';

import {Autocomplete} from "../../../../plugins/wpg-mindstyle-core/src/assets/js/components/autocomplete";

document.addEventListener('DOMContentLoaded', function () {
    
    initFixedHeader('#rmg-mma-navigation');
    initFixedHeader('.header-container');

    if (jQuery('.promo-banner-wrapper').length) {
        initFixedHeader('.promo-banner-wrapper');
    }

    if (jQuery('.moonphase-lint').length) {
        initFixedHeader('.moonphase-lint');
    }

    if (jQuery('.theme-navigation').length) {    
        initFixedHeader('.theme-navigation');
    }

    if (jQuery('.shop-category-menu-container').length) { 
        initFixedHeader('.shop-category-menu-container');
    }

    jQuery('.search-form').each(function() {
        new Autocomplete(this);
    });
});
